import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastHostComponent } from './shared/ui/toast/toast-host.component';
import { ToastService } from './shared/ui/toast/toast.service';

/**
 * The toast host lives here, not in the shell, so messages also show on Login and not-found. It is deferred to keep it
 * and its icons out of the initial bundle; a toast raised first loads it at once.
 */
@Component({
  imports: [RouterOutlet, ToastHostComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class App {
  private readonly toasts = inject(ToastService);

  protected readonly hasToasts = computed(() => this.toasts.toasts().length > 0);
}
